export const CHART_COLORS_ARRAY = [
  window.PRIMARY_COLOR ?? '#5C04B4',
  '#2478F0',
  '#A50FEC',
  '#ED3FA5',
  '#F66F1E',
  '#FFBA42',
  '#B47B1E',
];
